import { createUseStyles } from 'react-jss';
import { mobileContent } from '../../utils/mixins';
export default createUseStyles(theme => (Object.assign({ container: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        width: 518,
        minHeight: 292,
        padding: 10,
        top: '60px',
        oververflowY: 'auto',
        backgroundColor: 'rgba(255,255,255,1)',
        '& > span': {
            position: 'absolute',
            right: 10,
            top: 10,
            cursor: 'pointer',
            fill: 'black',
            zIndex: 1003,
        },
    }, overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 1003,
        backgroundColor: 'rgba(196, 196, 196, .8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflowY: 'auto'
    }, action: {
        minHeight: 657
    }, content: {
        width: 332,
        position: 'relative',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
    }, header: {
        color: theme.palette.grey[11],
        marginTop: 20,
    }, subtitle: {
        textAlign: 'center'
    } }, mobileContent({
    container: {
        width: '100%',
        minHeight: '100%',
        top: 0,
        left: 0,
    },
    content: {
        width: '100%',
        height: '100%',
        padding: 0
    }
}))));
//# sourceMappingURL=styles.js.map